const GATEWAY = process.env.REACT_APP_GATEWAY_URL || 'http://localhost:4000'

/**
 * The listed price of one made-to-order formulation, straight from the service
 * that charges it. GST-inclusive, like every price on this platform.
 *
 * `mrp` is null unless a genuinely higher list price is configured — the
 * storefront must never render a strikethrough against a price that was never
 * charged, so callers show the "was" line only when has_discount is true.
 */
export interface FormulationPricing {
  price:           number
  mrp:             number | null
  has_discount:    boolean
  discount_amount: number
  currency:        'INR'
}

/** Public — no auth. Throws so callers can hide their price UI on failure. */
export async function getFormulationPricing(): Promise<FormulationPricing> {
  const res  = await fetch(`${GATEWAY}/api/pricing/formulation`)
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Could not load pricing')
  return data as FormulationPricing
}
